export default "__VITE_ASSET__BsDgmk2X__"